import React from "react";
import NavBar from "../../components/navbar";
import { Container, Paper, Typography } from "@mui/material";
import { useErrorHandler } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { LoadInventoryByEan } from "../../../../domain/usecases/load-inventory-by-ean";

type Props = {
  loadInventory: LoadInventoryByEan;
};

export default function AdjustmentsMain({ loadInventory }: Props) {
  const navigate = useNavigate();

  return (
    <>
      <NavBar
        title="Ajustes"
        onBack={() => {
          navigate("/");
        }}
      />
      <Container
        sx={{
          display: "grid",
          gridTemplateColumns: "auto auto",
          gap: "50px",
          my: "70px",
        }}
      >
        <Paper
          sx={{
            mx: "50px",
            p: "20px",
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#00158E",
              color: "#FFF",
            },
          }}
          onClick={() => {
            navigate("batch");
          }}
        >
          <Typography fontSize={20} fontWeight={"bold"}>
            Ajustar Lotes
          </Typography>
        </Paper>
        <Paper
          sx={{
            mx: "50px",
            p: "20px",
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#00158E",
              color: "#FFF",
            },
          }}
          onClick={() => {
            navigate("inventory");
          }}
        >
          <Typography fontSize={20} fontWeight={"bold"}>
            Ajustar Estoque
          </Typography>
        </Paper>
      </Container>
    </>
  );
}
